import { muiTheme } from "@/styles/theme";
import { Box, Typography } from "@mui/material";

interface LeadHistoryHeaderProps {
  whodunnit: string;
  updatedAt: string;
  getDate: (date: string) => string;
}
export const HistoryCardHeader = ({
  whodunnit,
  updatedAt,
  getDate,
}: LeadHistoryHeaderProps) => {
  return (
    <>
      <Typography
        sx={{
          ...muiTheme.typography.body_sm_med,
          color: muiTheme.colorSchemes.light.palette.neutral[900],
          marginBottom: "16px",
        }}
      >
        {`${whodunnit || "system"} updated the lead ${getDate(updatedAt)}`}
      </Typography>
      <Box
        sx={{
          bgcolor: muiTheme.colorSchemes.light.palette.primary[50],
          display: "grid",
          gridTemplateColumns: "0.5fr 0.5fr 0.5fr",
          gap: "16px",
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "4px",
          paddingBottom: "4px",
          minHeight: "28px",
          borderRadius: "4px",
          marginBottom: "4px",
        }}
      >
        <Typography
          sx={{
            ...muiTheme.typography.body_sm_med,
            color: muiTheme.colorSchemes.light.palette.neutral[900],
          }}
        >
          Field
        </Typography>
        <Typography
          sx={{
            ...muiTheme.typography.body_sm_med,
            color: muiTheme.colorSchemes.light.palette.neutral[900],
          }}
        >
          Old value
        </Typography>
        <Typography
          sx={{
            ...muiTheme.typography.body_sm_med,
            color: muiTheme.colorSchemes.light.palette.neutral[900],
          }}
        >
          New value
        </Typography>
      </Box>
    </>
  );
};
